<template>
  <div id="guest_book">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all">
      <div class="con_box2" style="position: relative;">
        <router-link :to="{ name: 'new_guest_book'}">
          <button type="submit" class="gue_btn">{{showPage.leaveMessage}}</button>
        </router-link>
        <div class="gue_box" v-for="(book,index) in books" :key="index" v-if="inCurrentPage(index)">
          <div class="gue_box_user">
            <div class="gue_box_user_title">{{book.guestName}}<i class="fa fa-envelope-o ml5" aria-hidden="true"></i></div>
            <div class="gue_box_user_date">{{book.createdAt}}</div>
            <div class="gue_box_user_tx" v-html="changeBreak(book.guestMessage)">
              <!-- {{book.guestMessage}} -->
            </div>
            <div class="gue_box_ans" v-if="book.replyDisplay">
              <div class="gue_box_ans_title"><i class="fa fa-comments-o mr5" aria-hidden="true"></i>{{showPage.reply}}</div>
              <div class="gue_box_ans_date">{{book.updatedAt}}</div>
              <div class="gue_box_ans_tx" v-html="changeBreak(book.reply)">
                <!-- {{book.reply}} -->
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-row text-center ml20">
          <Page :total="books.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
        </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'guest_book',
  data() {
    return {
      spinShow: true,
      books: [],
      currentPage: 1,
      pagesize: 10,
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    changeBreak(str) {
      var index = 0;
      var index2 = 0;
      while (str.indexOf("\n", index) != -1) {
        str = str.replace("\n", "<br />");
        index = str.indexOf("\n", index);
      }
      while (str.indexOf("&#10;", index2) != -1) {
        str = str.replace("&#10;", "<br />");
        index2 = str.indexOf("&#10;", index2);
      }

      return str
    },
    init() {
      this.initBooks();
    },
    initBooks() {
      this.getBooksData();
    },
    getBooksData() {
      axios.get(API.message)
        .then(response => {
          //for (var i = response.data.length - 1; i >= 0; i--) {
          //  this.books.push(response.data[i])
          //}
          this.books = response.data;
          this.books = this.books.filter(data => {
            return data.trash !== 1 && data.isDisplay === 1;
          });
        })
        .then(() => {
          this.spinShow = false
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// GuestBook.vue?0fa761b6